import { useDeleteBreakdownDocument } from '@/hooks/useBreakdownDocuments';
import { ConfirmDialog } from './ConfirmDialog';

export interface DeleteDocumentConfirmProps {
  jobId: string;
  document: { id: string; name: string; isActive: boolean } | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function DeleteDocumentConfirm({
  jobId,
  document,
  open,
  onOpenChange,
}: DeleteDocumentConfirmProps) {
  const deleteDoc = useDeleteBreakdownDocument(jobId);

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete version"
      description={
        <>
          Permanently delete <strong>{document?.name ?? ''}</strong>? This
          cannot be undone.
          {document?.isActive && (
            <span className="block mt-2 text-amber-700">
              This version is currently Active — set another version as
              Active first.
            </span>
          )}
        </>
      }
      confirmLabel="Delete"
      confirmingLabel="Deleting..."
      variant="destructive"
      // Block the click before it even hits the server when this doc is the
      // Active one for its slot. The hook also toasts on the same condition
      // (ACTIVE_DOCUMENT_DELETE_BLOCKED) for races, but this avoids a
      // pointless network round-trip when we already know it'll fail.
      confirmDisabled={!document || document.isActive}
      onConfirm={async () => {
        if (!document) return;
        await deleteDoc.mutateAsync(document.id);
      }}
    />
  );
}
